export const localization = {
    pt: {
        locale: 'pt-BR',
        successRemovedHost: 'Host removido com sucesso',
        cancel: 'Cancelar',
        disable: 'Deletar',
        caution: 'Atenção',
        confirmMessage: 'Deseja realmente deletar esse host? Esta ação nao pode ser desfeita!',
        failRemovedHost: 'Falha ao tentar deletar host.',
    },
    en: {
        locale: 'en-US',
        successRemovedHost: 'Host removed successfully',
        cancel: 'Cancel',
        disable: 'Delete',
        caution: 'Caution',
        confirmMessage: 'Do you really want to delete the host? This action can\'t be undone',
        failRemovedHost: 'Failed when trying to delete host.',
    },
    es: {
        locale: 'es-ES',
        successRemovedHost: 'Host eliminado exitosamente',
        cancel: 'Cancelar',
        disable: 'Borrar',
        caution: 'Atención',
        confirmMessage: '¿Realmente desea borrar este host? ¡Esta acción no se puede deshacer!',
        failRemovedHost: 'Error al intentar borrar el host.',
    },
};
